import { Radio } from "@headlessui/react";
import Typography from "../typography";
import RadioStyled from "./radioStyled";

interface Props {
  id: string;
  text: string;
  value: number | boolean | string;
  large?: boolean;
  disabled?: boolean;
}

/**
 * Component for a radio button.
 * @param interface
 * @returns a radio button.
 */
const RadioComponent = ({ id, value, text, large = false, disabled = false }: Props) => {
  const variant = large ? "Body" : "Description";
  return (
    <Radio value={value} disabled={disabled} className="group flex items-center space-x-2 hover:cursor-pointer">
      <RadioStyled id={id} />
      <label htmlFor={id} className="group-data-disabled:text-gray-400">
        <Typography variant={variant}>{text}</Typography>
      </label>
    </Radio>
  );
};

export default RadioComponent;
